"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutocompleteValue = void 0;
const lodash_1 = require("lodash");
function useAutocompleteValue(props) {
    const { value, labelMapper, multiple, freeSolo } = props;
    const autocompleteValue = {
        text: '',
        single: null,
        multiple: [],
        setText(value) {
            this.text = value;
        },
        getTextLabel() {
            return this.text;
        },
        setSingle(value) {
            this.single = value;
        },
        getSingleLabel() {
            if (!this.single) {
                return '';
            }
            return labelMapper(this.single, 'FIELD');
        },
        setMultiple(values) {
            const sorted = values.sort((a, b) => labelMapper(a, 'FIELD') > labelMapper(b, 'FIELD') ? 1 : -1);
            this.multiple.push(...sorted);
        },
        getMultipleIds() {
            return this.multiple.map((value) => value.id);
        },
        getMultipleLabel() {
            return this.multiple
                .map((value) => labelMapper(value, 'FIELD'))
                .join('; ');
        },
        getLabel() {
            if (multiple) {
                return this.getMultipleLabel();
            }
            if (freeSolo) {
                return this.getTextLabel();
            }
            return this.getSingleLabel();
        },
    };
    if (freeSolo && value !== undefined) {
        if (multiple) {
            console.error('Autocomplete with "freeSolo" and "multiple" at the same time is not supported. Use TextFieldMultiple instead.');
        }
        if (typeof value === 'string' || value === null) {
            autocompleteValue.setText(value !== null && value !== void 0 ? value : '');
        }
        else {
            console.error(`Autocomplete value with set "freeSolo" must have string value. Received: ${value}`);
        }
    }
    if (!freeSolo && value !== undefined) {
        if (multiple) {
            if (Array.isArray(value) || value === null) {
                autocompleteValue.setMultiple(value !== null && value !== void 0 ? value : []);
            }
            else {
                console.error(`Autocomplete value with set "multiple" must have array value. Received: ${value}`);
            }
        }
        if (!multiple) {
            if (lodash_1.isPlainObject(value) || value === null) {
                autocompleteValue.setSingle(value);
            }
            else {
                console.error(`Autocomplete must have object value. Received: ${value}`);
            }
        }
    }
    return autocompleteValue;
}
exports.useAutocompleteValue = useAutocompleteValue;
//# sourceMappingURL=autocomplete-value-hook.js.map